module.exports = __webpack_public_path__ + "img/emp_markus_0.b1473636.png";